import _ from "lodash";
import JSZip from "jszip";
import moment from 'moment-timezone';
import i18n from '@/plugins/i18n';
import router from "../../src/routes/router";

/*!
 * Helpers
 * ---
 * Declare here all the helper functions that you app needs. Keep this file with
 * simple logic functions for more complex logic put it in other folder.
 */
export const SCHEMA_URL = '/schema';
export const displayName = name => name != null ? name.replace(/(\_[\d]+)$/, '') : "";

export const updateSchema = async (store, axios, timeout = 0) => {
  if (timeout) {
    setTimeout(() => {
      updateSchemaOnState(store, axios);
    }, timeout);
  }
  else {
    updateSchemaOnState(store,axios);
  }
}

/**
 * * Gets a zip file from given URl returns file object - JSZip
 * @param {string} zipUrl
 * @returns JSzip object
 */
export const ZipFile = async (zipUrl, axios) => {
  try {
    const zipResponse = (await axios.get(zipUrl, {responseType: 'arraybuffer'})).data;
    return await JSZip.loadAsync(zipResponse);
  } catch(err) {
    console.error(`[ZIP ERROR] ${err}`); // console error
    throw err;
  }
}

/**
 * Decompress a file from a JZip object
 * @param {JZip} zipInfo zip file info
 * @param {string} fileName file name to decompress from the zip
 * @param {string} getContentAs Name of the type of data to return by default data will be returned as string
 * @returns {*} data according to the content specified as in getContentAs
 */
export const getFileFromZip = async (zipInfo, fileName, getContentAs = 'string') => {
  let file = zipInfo.file(fileName);
  if (file == null)
    throw `FILE NOT FOUND: ${fileName}`;
  return await file.async(getContentAs);
}

export const updateSchemaOnState = async (store, axios) => {
  const schemaZipFile = await ZipFile(SCHEMA_URL, axios);
  const schemaJsonString = await getFileFromZip(schemaZipFile, "schema.min.json");
  window.$Schema = JSON.parse(schemaJsonString);
  store.commit('SET_SCHEMA', window.$Schema)
}

export const isFieldList = (field, entity) => {
  try {
    return (field.options && field.options.length > 0) || !!ENV.ENTITIES[entity.name].fields[field.name].options
  } catch {
    return false
  }
}

/**
 * Check the env to see if is the given entity is must load extradata.
 * ------------------------------
 * @function isExtraDateable
 * @param {Object|string} API | Entity Object.
 * @return {Boolean} | tru if the entity must load extradata
 */
export const isExtraDateable = function (entity) {
  return !(ENV.ENTITIES[entity.name] && ENV.ENTITIES[entity.name].excludeExtraData === true)
}

/*
Get CustomLabel object for ENV.ENTITIES
*/
export const getCustomLabel = function (entityName) {
  return ENV.ENTITIES[entityName] && ENV.ENTITIES[entityName].customLabels
}

/* TODO: docs */
export const addGlobalWhere = where => {
  var GlobalWheres = localStorage.getItem('GlobalWheres')
  GlobalWheres = GlobalWheres ? JSON.parse(GlobalWheres) : [];
  GlobalWheres.push(where);
  GlobalWheres = _.uniq(GlobalWheres);
  localStorage.setItem('GlobalWheres', JSON.stringify(GlobalWheres));
}

/* Set Current Language */
export const selectLanguage = language => {
  localStorage.setItem('CurrentLanguage', language)
}

/* TODO: docs */
export const selectBusinessScopeId = id => {
  localStorage.setItem('BusinessScopeId', id)
}

/* TODO: docs */
export const selectBusinessScope = (scope, store) => {
  localStorage.setItem('GlobalWheres', '[]')
  selectBusinessScopeId(scope.id)
  localStorage.setItem(ENV.SCOPE, scope.path);

  if (store) store.dispatch('setBusinessScope', scope);
}

/* TODO: docs */
export const getBusinessScopeId = () => localStorage.getItem('BusinessScopeId')

/* TODO: docs */
export const getGlobalWheres = () => JSON.parse(localStorage.getItem('GlobalWheres') || "[]")

/* TODO: docs */
export const uid = pattern => {
  return (pattern || 'xxxxx-xxxxx-xxxxx').replace(/x/g, c => (Math.random() * 16 | 0).toString(16))
}

/* TODO: docs */
export const ucfirst = s => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

/* TODO: docs */
export const lcfirst = s => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toLowerCase() + s.slice(1)
}

/* TODO: docs */
export const pascalToSnake = s => {
  if (typeof s !== 'string') return ''
  return s.replace(/[A-Z]/g, a => `-${a.toLowerCase()}`).slice(1)
}

/* TODO: docs */
export const snakeToPascal = s => {
  if (typeof s !== 'string') return ''
  return `${s.charAt(0).toUpperCase()}${s.replace(/-(\w)/g, (_, b) => b.toUpperCase()).slice(1)}`
}

/* TODO: docs */
export const camelToPascal = s => {
  if (typeof s !== 'string') return ''
  return ucfirst(s)
}

/* TODO: docs */
export const pascalToCamel = s => {
  if (typeof s !== 'string') return ''
  return lcfirst(s)
}

/* TODO: docs */
export const replaceUnderscoreToSpace = s => {
  if (typeof s !== 'string') return ''
  return s.replace(/_/g, " ")
}

/* TODO: docs */
export const pascalToHuman = s => {
  if (typeof s !== 'string') return ''
  return s.replace(/[A-Z]/g, a => ` ${a}`).slice(1)
}

/* TODO: docs */
export const relationName = (field) => {
  return stringToCamel(field.name)
}

/* TODO: docs */
export const waiter = (promise) => promise
  .then(solved => [solved])
  .catch(error => [null, error])

/* TODO: docs */
export const tryPromise = (promise, data = true) => promise
  .then(result => data ? result.data : result)
  .catch(error => error)

/* TODO: docs */
export const fields = (entity, flag, ignoreTypes = [], only = [], ignore = [], isSection = false) => {
  var ignoreFields = [];
  if (!isSection) {
    try { ignoreTypes = ignoreTypes.concat(ENV.ENTITIES[entity.name].ignore)  }
    catch { ignoreTypes = ignoreTypes }
    try { ignoreFields = ignoreFields.concat(ENV.ENTITIES[entity.name].ignore)  }
    catch { ignoreFields = [] }
  }
  if (!entity || !entity.fields) return [];
  return entity.fields
    .map((o, index) => ({ ...o, index }))
    .filter(f => flag != null ? f[flag] : true)
    .filter(f => !ENV.ENTITY.FIELDS.IGNORE.some(i => {
      // fix for external id field since it ends with "id"
      if (f.name == 'externalId' && i == 'externalId') // if it is actually ignored
        return true;
      else if (f.name == 'externalId') // if not ignored
        return false;
      return (f.name.endsWith(i) && !f.extra); // THIS WAS THE DEFAULT BEHAVIOUR - if not external id but ends with some field name (except extraFields)
    }))
    .filter(f => !ignoreTypes.find(ii => f.type === ii))
    .filter(f => !ignoreFields.find(ii => f.name === ii))
    .filter(f => !only.length ? true : only.find(ii => f.name === ii))
    .filter(f => !ignore.find(ii => f.name === ii))
    .map(f => {
      return { ...f, ..._.get(ENV, `ENTITIES[${entity.name}].fields[${f.name}]`, {}) };
    })
}

export const isGloballyDisabled = (field, entity = null) => {
  if (ENV.ENTITY && ENV.ENTITY.FIELDS && ENV.ENTITY.FIELDS.DISABLED) {
    return ENV.ENTITY.FIELDS.DISABLED.some(fieldName => fieldName == field.name);
  }
  return false;
}

/* TODO: docs */
export const searchEntity = function (name, by = 'name', sectioned = true) {
  // Add sections to search entity
  const entity = this.$store.state.schema.all.find(s => s[by] === name)
  if (!sectioned || !entity) return entity;

  let entityCopy = { ...(entity || {}) };
  const toSections = { businessScope: name, criterias: name }
  entityCopy.fields = sectionedFields(entityCopy, toSections)
  return entityCopy;
}

/* TODO: docs */
export const findEntity = function (name) {
  return searchEntity.call(this, name, 'name');
}

/* TODO: docs */
export const formatErrors = (errors, relation) => {
  let relationName = relation.name;
  if (!relationName) return {};
  relationName = relationName.replace(/\_[\d]+/, '');
  relationName = setCustomErrorsTab(relationName)
  // if(relationName != null) relationName = relationName.charAt(0).toUpperCase() + relationName.slice(1)
  return Object.keys(errors)
    .filter(k => k.includes(relationName))
    .map(k => ({ [k.replace(relationName, '').replace('.', '')]: errors[k]}))
    .reduce((a, b) => ({...a, ...b}), {})
}

/*
Replace sectionName for custom tab name, for render error purpose
When the related entity is "packagesContents", replaced it with "ShipmentItem", From backed it comes like this
When the related entity is "pickupDelivery", it means the entity is its father, "Shipment"
*/
export const setCustomErrorsTab = function (relationName) {
  relationName = relationName.replace("packagesContents","ShipmentItem")
  relationName = relationName.replace("pickupDelivery", "Shipment")
  return relationName;
}

/* TODO: docs */
export const fieldsToHeaders = (entity, fields) => {
  // console.log(`[$fieldsToHeaders]`, entity.name, fields);
  // debugger;

  const addedHeaders = _.get(ENV.ENTITIES, entity.name + '.index.add', []);
  const translatedHeaders = _.map(addedHeaders, f => {
    const i18nPath = f.i18nPath || f.value;
    return { ...f, text: tCheck(`${entity.name}.${i18nPath}`, f.text) };
  });

  const headers = fields
    .filter(f => !_.get(ENV.ENTITIES, entity.name + '.index.ignore', []).some(i => f.name.endsWith(i)))
    .filter(f => f.indexable === undefined ? true : f.indexable)
    .map(f => ({ text: tCheck(`${entity.name}.${f.name}`, camelToString(f.name)), value: lcfirst(f.name), type: f.type  }))
    .concat(translatedHeaders)
  return [{ text: tCheck('Common.actions'), value: 'action' }].concat(headers);
}

export const getExtraDataForIndex = (store, entity) => {
  const indexConfig = getIndexConfig(store, entity);
  if (indexConfig) {
    return indexConfig.filter( h => /([a-zA-Z0-9_]+)_([0-9]+)\.([a-zA-Z0-9_]+)/.test(h.value))
      .map(h => {
        let allPieces = h.value.split(".");
        let groupPieces = allPieces[0].split("_");
        groupPieces.splice(groupPieces.length -1);
        return `${groupPieces.join("_")}.${allPieces[1]}`;
      });
  }
  return [];
};

export const getIndexConfig = (store, entity) => {
  if (store.state.config && store.state.config.index)
    return store.state.config.index[entity];
};

/* TODO: docs */
export const scope = () => window.localStorage.getItem(ENV.SCOPE)

/* TODO: docs */
export const fetchEntity = async (instance, load, axios) =>
  (await axios.get(`${instance._Entity}/${instance.uid}`, {
    params: { load }
  })).data

/* TODO: docs */
export const groupBy = (xs, key) => xs.reduce((rv, x) => {
  (rv[x[key]] = rv[x[key]] || []).push(x);
  return rv;
}, {});

/* TODO: docs */
export const replasable = (relation, parent = {}, isMultiple = false) => {
  return (!['Party'].includes(parent.name) && ENV.REPLASABLE_COMPONENTS[isMultiple ? 'Multiple' : 'Single'][relation])
    || localReplasable(relation, parent.name);
}

export const localReplasable = (relation, parentName) => {
  try {
    return ENV.ENTITIES[parentName].replaceSection[relation]
  } catch(e) {
    return null;
  }
}

/**
 * @param {String} entity
 * @returns {String}
 */
export const findEntityIcon = (entity) => ENV.ENTITY_ICONS[entity.toLowerCase()]

/**
 * @param {Object|String} err
 * @returns {String}
 */
export const getFieldOptions = (field, entity) => {
  try{
    return (entity && ENV.ENTITIES[entity.name].fields[field.name].options)
  } catch { return field.options || [] }
}

/**
 * @param {Object|String} err
 * @returns {String}
 */
export const getConfigValue = (path, defaultValue = null) => {
  return _.get(ENV, path, defaultValue);
}

/**
 * @param {Object|String} err
 * @returns {String}
 */
export const errorParse = (err) => {
  if (err.response) {
    return err.message
  } else if (err.request) {
    return err.request
  } else {
    return err
  }
}

/**
 * @returns {array}
 *
 * Returns the list of entities from schema that are navigable for a user, filters by the configuration given in ENV
 */
export const allNavigableScreens = function() {
  var ignore = []
  var replace = []
  try {ignore = ENV.ENTITY.IGNORE_FROM_SIDEBAR } catch {ignore = []}
  try {replace = ENV.ENTITY.REPLACE_FROM_SIDEBAR } catch {replace = []}
  return this.$store.state.schema.all.filter(e => e.alias === null && !e.template && !e.extra && (e._Entity !== 'Portal') && !ignore.find(_ => _ === e.name))
   .map(p => replace.find(x => x.from == p.name) ? {...p, label: replace.find(x => x.from == p.name).to} : p);
}

/**
 * @param {String} entity
 * @param {String[]} args - String with extra dependencies to load
 * @returns {String}
 *
 * Fetch is an alias of axios.get that receives the name of the entity and the extra arguments are
 * correspoding loading
 */
export const fetchLoad = (entity, queryable = true, ...args) => {
  let res = `${entity}`
  const separator = 'load[]='
  if (!_.isEmpty(args)) res += `${queryable ? '?' : '' }${args.map(x => separator + x).join('&')}`
  return res
}

/* TODO: docs */
export const stringToCamel = s => {
  if (typeof s !== 'string') return ''
  let words = toWords(s)
  return toCamel(words)
}

export const toWords = s => {
  if (typeof s !== 'string') return ''
  const regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
  return s.match(regex)
}

export const toCamel = s => {
  let res = ""
  for(let i = 0, len = s.length; i < len; i++) {
    let currentStr = s[i]
    let tempStr = currentStr.toLowerCase();
    if (i != 0) {
      tempStr = tempStr.substr(0,1).toUpperCase() + tempStr.substr(1);
    }
    res += tempStr;
  }
  return res;
}

export const camelToString = s => {
  if (typeof s !== 'string') return ''
  return _.startCase(s)
}

/* TODO: docs */
export const getParentKey = (parent, path) => {
  return _.get(ENV, `ENTITIES[${parent.name}].keys[${path}]`, `${path}Id`);
}

/* TODO: docs */
export const ignoreTimezone = (entity, key) => {
  return _.get(window.ENV.ENTITIES[entity] || {}, `fields.${key}.ignoreTimezone`);
}

/* TODO: docs */
export const dateFormatted = (date) => {
  return date != null ? date.format('DD-MMM-YYYY HH:mm') : null;
}

/* TODO: docs */
export const dateTimezoneConvert = (date, originalTimezone, targetTimezone) =>
{
  const destinationTz = _.isEmpty(targetTimezone) ? 'Etc/GMT' : targetTimezone;
  const originalInput = moment.tz(date, originalTimezone).format();
  return moment(originalInput).tz(destinationTz);
}

/* TODO: docs */
export const getSchemaAction = function (name, attribute) {
  return this.$store.state.schema.all.find(f => name == f.name).actions[attribute] || false;
}

export const generateUid = function () {
  let dt = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (dt + Math.random()*16)%16 | 0;
    dt = Math.floor(dt/16);
    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
  });
  return uuid;
}
/*Get the value of an extradata
<param name="extraData">entity to evaluate its extradata</param>
<param name="header">Object that contains the value(Name of the 'ExtrafieldGroup.ExtraData') and the type</param>
*/
export const getExtraFieldValue = function ({ extraData }, header) {
  const found = _.find(extraData, ['key', header.value]);
  var value = _.get(found, 'value', '');
  if(header.type && header.type == 'DateTime'){
    const momentDate = moment(value)
    return momentDate.isValid() ? this.$dateFormatted(momentDate) : value;
  }
  return  value;
}

/*Get the value of an extradata by extrafieldId instead of key
<param name="extraData">entity to evaluate its extradata</param>
<param name="header">Object that contains the value(Name of the 'ExtrafieldGroup.ExtraData') and the type</param>
*/
export const getExtraFieldValueById = function ({ extraData }, { extraFieldId, type }) {
  const found = _.find(extraData, ['extraFieldId', extraFieldId]);
  var value = _.get(found, 'value', '');
  if(type && type == 'DateTime'){
    const momentDate = moment(value)
    return momentDate.isValid() ? this.$dateFormatted(momentDate) : value;
  }
  return  value;
}

/**
 * Get globalConfig extraloads for the relation call
 * @param {*} parent
 * @param {*} entity
 */
export const relationLoads = function (parent, entity) {
  return _.get(ENV.ENTITIES, `${parent.name}.relationLoads.${entity.name}`, []);
}

/**
 * Get globalConfig extraloads for the entity call
 * @param {*} parent
 * @param {*} entity
 */
export const entityLoads = function (entity) {
  return _.get(ENV.ENTITIES, `${entity.name}.entityLoads`, []);
}

/*
Find on schema if a specific entity has a specific action
*/
export const showEntity = function (entityName, entityAction) {
  let entity = this.$store.state.schema.all.find(f => entityName == f.name)
  return entity.actions[entityAction];
}

/* TODO: docs */
export const downloadFile = async function (file, axios) {
  var { data } = await axios.get(`/file/media/info/${file.uid}`);
  window.open(data.downloadUrl, "_blank");
}

/**
 * Overrides field properties (defined by the user) from one array to another
 * looking for matching fields.
 * @param {Array} fieldsOld
 * @param {Array} fieldsNew
 * @param {Array<string>}
 * @returns {Array}
 */
export const overrideFields = (
  fieldsOld,
  fieldsNew,
  [mapOld = 'name', mapNew = 'name', mapTo = 'name']
) => {
  return fieldsOld.map(fo => {
    let field;

    if (field = fieldsNew.find(fn => fn[mapOld] === fo[mapNew])) {
      return { ...fo, [mapTo]: field[mapNew] };
    }

    return fo;
  });
}

export const sortByUISequence = (fields) => {
  return _.sortBy(fields, ({ uiSequence }) => { return uiSequence || 0; });
}

export const getStorageUser = () => {
  const userLocal = window.localStorage.getItem('geodis-user');
  return userLocal && JSON.parse(decodeURIComponent(window.atob(userLocal)));
}

// Normal use: Receives entity and a dictionary of section with format Relation: Parent Tab.
// Ex: sectionedFields(Shipment, { criterias: 'Shipment' })
// Will convert criterias relation to a section of the Shipment Tab and return the fields.
export const sectionedFields = ({ fields = [] }, sections = {}) => {
  const sectionedFields = fields.map(f => {
    if (sections[f.name]) {
      return { ...f, section: sections[f.name] }
    }
    return f;
  });

  return sortFields(sectionedFields, ['businessScope', 'criterias']);
}

export const sortFields = (fields = [], orderList = [], filter = []) => {
  const sortedFields = _(fields).sortBy((obj) => _.indexOf(orderList, obj.name)).value();
  if (filter && filter.length > 0) return sortedFields.filter(f => !filter.includes(f.name));
  return sortedFields;
}

/* TODO: docs */
export const formattedDate = function (date, setTimezone = false) {
  const momentDate = moment(date);
  if (!momentDate.isValid()) return null;
  if (setTimezone) {
    const dateWithTz = moment.parseZone(date);
    return dateWithTz.format("DD-MMM-YYYY HH:mm Z");
  }
  return momentDate.format("DD-MMM-YYYY HH:mm");
}

///If the given string is null, return an empty string
///Else return the given string
export const cleanNulls = function (string) {
  if(string == null) return '';
  return string;
}

export const hasEmbeddedQuery = ($route) => $route.query && _.get($route.query, 'embedded') == 'True';
export const isAuthRoute = (route) => !!route.path.match('/auth/')
export const isEmbeddableRoute = (route) => !!route.name && route.name.startsWith('embeddable')
export const routeType = ($route) => {
  if (isAuthRoute($route) && !hasEmbeddedQuery($route))
    return authRoute();
  else if (!isAuthRoute($route) && !isEmbeddableRoute($route))
    return normalRoute();
  else if (hasEmbeddedQuery($route) || isEmbeddableRoute($route))
    return embeddableRoute()
  else
    return unknownRoute()
}
export const normalRoute = () => "normal"
export const authRoute = () => "auth"
export const embeddableRoute = () => "embeddable"
export const unknownRoute = () => "unknown"

export const hasBusinessScope = (user, businessScopePath = 'GEODIS') => {
  if (user.userRoleBusinessScopes && Array.isArray(user.userRoleBusinessScopes))
    return user.userRoleBusinessScopes.some((roleBs) => roleBs.businessScope && roleBs.businessScope.path == businessScopePath)
  return false
}
export const getBusinessScopeFromUser = (user, businessScopePath = 'GEODIS') => {
  if (user.userRoleBusinessScopes && Array.isArray(user.userRoleBusinessScopes)) {
    let roleScope = user.userRoleBusinessScopes.find(
      (roleBs) => roleBs.businessScope && roleBs.businessScope.path == businessScopePath
    )
    if (roleScope)
      return roleScope.businessScope

  }
  return null
}

export const tCheck = (path, fallback = null, args = {}) => {
  return i18n.te(path) ? i18n.t(path, args) : (fallback || path);
}
export const tCheckC = (path, fallback = null, args = {}) => {
  return i18n.te(path) ? i18n.tc(path, args) : (fallback || path);
}

//This is a function created to comply with CWE-117 vulnerability (CRLF Injection)
// It simply removes possible returns and injected keys into the log.
export const cleanString = function(input) {
  if(_.isString(input)) return input.toString().replace(/\n|\r/g,'');
  else return input;
}

export const getInitialCriterias = function(criteriaObj, whereArray) {
  let initCriterias = [];
  if (criteriaObj) initCriterias.push(criteriaObj);
  if (whereArray) {
    _.forEach(whereArray, (criteria) => {
      initCriterias.push({ value: criteria, label: criteria });
    });
  }
  return initCriterias;
}

/**
 * @desc
 * It ensure the route is being pushed after saving to Storage,
 * otherwise the props can change due to new route.
 * @deprecated wheres are only needed by the current session.
 */
export const savePaginationAndRoute = function(entityName, pagination, options, route) {
  const cleanedPagination = {
    desc: pagination.desc,
    load: pagination.load,
    pageSize: pagination.pageSize,
    total: pagination.total,
    totalPages: pagination.totalPages,
    // where: pagination.where,
    orderby: pagination.orderBy
  };
  options.page = pagination.page;
  localStorage.setItem(`pagination${entityName}`, JSON.stringify(cleanedPagination));
  localStorage.setItem(`options${entityName}`, JSON.stringify(options));
  router.push(route);
}

export const getSavedPagination = function(entityName) {
  const paginationStore = localStorage.getItem(`pagination${entityName}`);
  const optionsStore = localStorage.getItem(`options${entityName}`);
  const whereStore = sessionStorage.getItem(`${entityName}_filters`);
  let pagination = {};
  let options = null;

  if (whereStore) {
    pagination.where = JSON.parse(whereStore);
  }

  if (paginationStore && optionsStore) {
    try {
      pagination = {
        ...JSON.parse(paginationStore),
        where: pagination.where,
      };
      options = JSON.parse(optionsStore);
    } catch(e) {
      console.log(e)
    } finally {
      localStorage.removeItem(`pagination${entityName}`);
      localStorage.removeItem(`options${entityName}`);
      return { pagination, options };
    }
  } else {
    return { pagination, options };
  }
}

export const csvToHtmlTable = function(csvString , delimiter = ",", tableClass = "csv-table") {
  let rows = csvString.split("\n"); // Split the CSV string into an array of rows
  let table = `<table class="${tableClass}">`; // Start building the HTML table
  for (let i = 0; i < rows.length; i++) { // Loop through each row
    if (i == 0 && rows[i].startsWith("SEP=")) // if first line is the delimeter definition (separator) continue to next line
      continue;
    let cells = []; // Array to store cells in this row
    let currentCell = ""; // String to build the current cell
    let inQuotes = false; // Whether the current cell is in quotes
    for (let j = 0; j < rows[i].length; j++) { // Loop through each character in the current row
      if (rows[i][j] === '"') { // If this character is a quote
        if (rows[i][j - 1] !== '\\') { // If the preceding character is not a backslash
          inQuotes = !inQuotes; // Toggle the inQuotes flag
        } else {
          currentCell = currentCell.slice(0, -1) + '"'; // Add the quote to the current cell
        }
      } else if (rows[i][j] === delimiter && !inQuotes) { // If the current character is a comma and not in quotes
        cells.push(currentCell); // Push the current cell to the cells array and start a new one
        currentCell = "";
      } else {
        currentCell += rows[i][j]; // Add this character to the current cell
      }
    }
    cells.push(currentCell); // Push the final cell in this row to the cells array
    table += "<tr>"; // Add this row to the HTML table
    for (let j = 0; j < cells.length; j++) {
      let cellText = cells[j].replace(/\\"/g, '"'); // Replace any escaped quotes with actual quotes
      cellText = cellText.replace(/^"(.*)"$/, "$1"); // Remove the surrounding quotes, if any
      let cellElement = document.createElement("td");
      cellElement.textContent = cellText;
      table += cellElement.outerHTML;
    }
    table += "</tr>";
  }
  table += "</table>"; // Close the HTML table
  return table;
}

export function removeFirstCriteriaLogicalOperator(criterias) {
  const filteredCriterias = criterias.filter(c => c.entityState !== 2);
  if (filteredCriterias.length > 0) {
    const firstFilteredCriteria = filteredCriterias[0];
    if (firstFilteredCriteria) {
      const regexPattern = /^\s*(\|\||&&)/;
      if (regexPattern.test(firstFilteredCriteria.value)) {
        const firstCriteriaValue = firstFilteredCriteria.value.replace(regexPattern, '').trim();
        const i = criterias.indexOf(firstFilteredCriteria);
        criterias[i].value = firstCriteriaValue;
      }
    }
  }
}
